export default __webpack_public_path__ + "static/media/classs_img.2d28401c.png";